import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/index'
import LoginRoute from './login'
import personnelRoute from './personnel'
import RoleRoute from './role'
import JobRoute from './job'
import ContactRoute from './contact'
import JobPositionRoute from './JobPosition'
import CityRoute from './city'
import BannerRoute from './banner'
import VideoRoute from './video'
import NewsRoute from './news'
import GameRoute from './game'
import PartnerRoute from './partner'
import MenuRoute from './menu'
import LanguageGameRoute from './language'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        ...personnelRoute,
        ...RoleRoute,
        ...JobRoute,
        ...ContactRoute,
        ...JobPositionRoute,
        ...CityRoute,
        ...BannerRoute,
        ...VideoRoute,
        ...NewsRoute,
        ...GameRoute,
        ...PartnerRoute,
        ...MenuRoute,
        ...LanguageGameRoute
      ]
    },
    ...LoginRoute
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js